import Vue from "vue";

export default {
  fetchEmployeeHomeDetails({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/home/ess")
        .then(response => {
          commit("HOME_MUTATIONS", {
            key: "employeeHomeProfile",
            value: response.data,
          });
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchActivityLogs(_, data) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get("/home/activity-logs", { params: data })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
